import { openExternalLink, isExternalUrl } from "@utils/externalLinks";
import { useEffect } from "react";

export function ExternalLinkPreferenceBridge() {
	useEffect(() => {
		const handleClick = (event: MouseEvent) => {
			if (
				event.defaultPrevented ||
				event.button !== 0 ||
				event.metaKey ||
				event.ctrlKey ||
				event.shiftKey ||
				event.altKey
			) {
				return;
			}

			const element = event.target;
			if (!(element instanceof Element)) return;
			const anchor = element.closest<HTMLAnchorElement>("a[href]");
			if (
				!anchor ||
				anchor.hasAttribute("download") ||
				!isExternalUrl(anchor.href)
			) {
				return;
			}

			event.preventDefault();
			openExternalLink(anchor.href);
		};

		document.addEventListener("click", handleClick, true);
		return () => document.removeEventListener("click", handleClick, true);
	}, []);

	return null;
}
